
<div *ngFor="let img of images; index as ix">

  <img *ngIf="i_img==ix" [src]="img.url" style="width: 100%;" >

</div>
